import getConfig from 'next/config'

import { RedirectConfig } from './redirectMappingsTypes'

const { publicRuntimeConfig } = getConfig()

export const departmentRedirects: RedirectConfig[] = [
  {
    source: /department\/MOT-CAR.*/,
    destination: `${publicRuntimeConfig.CARS_BASE_URL}/cars/`,
    permanent: true,
  },
  {
    source: /department\/MOT-AUT.*/,
    destination: `${publicRuntimeConfig.CARS_BASE_URL}/automobilia/`,
    permanent: true,
  },
  {
    source: /department\/MOT-CYC.*/,
    destination: `${publicRuntimeConfig.CARS_BASE_URL}/motorcycles/`,
    permanent: true,
  },
  {
    source: /^\/jewelry\/?$/,
    destination: '/departments/JWL/',
    permanent: true,
  },
  {
    source: /^\/departments(.*)/,
    destination: `/department{{0}}`,
    permanent: true,
  },
]
